import { useContext, useState } from "react";
import { Box, Typography } from "@mui/material";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

import globalStyles from "../../../../../../assets/styles/global.module.scss";
import styles from "../../../../../../assets/styles/componentStyles/organizationTeamsStyles/teams.module.scss";

import GlobalButton from "../../../../../utility/globalButton/button";
import GlobalDeletePopup from "../../../../../utility/globalDeletePopup/globalDeletePopup";
import { organizationTeamsData } from "../../../../../../models/axiosModel";
import { UserContext, UserContextPayload } from "../../../../../../context/userContext";
import { useOrganizationTeamsStore } from "../../../../../../store/organizationTeamsStore";
import { useShallow } from "zustand/react/shallow";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGenericStore } from "../../../../../../store/genericStore";

interface Props {
    team: organizationTeamsData;
}

const TeamSettings = (props: Props) => {

    const { team } = props;

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const organization_id = searchParams.get("organization_id");

    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const { handleDeleteTeam } = useOrganizationTeamsStore(
        useShallow((state) => ({
            handleDeleteTeam: state.handleDeleteTeam,
        }))
    );

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [deleteTeamPopup, setDeleteTeamPopup] = useState(false);

    // Delete Team
    const handleDeleteTeamApiCall = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        const res = await handleDeleteTeam();
        if(!(res.status)){
            handleError(res);
        }
        else {
            showSuccess("Team Deleted Successfully!")
            navigate(`/organization/teams?organization_id=${organization_id}`);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    }

    return (
        <>
            <Box className={`${globalStyles.fullwidth} ${styles.teamDetailsSettingsContainer}`}>
                
                <Typography className={styles.teamDetailsHeaderTitle}>
                    Team Settings
                </Typography>

                <Typography className={styles.teamDetailsSettingsDescription}>
                    Permanently remove this team and its member assignments.
                </Typography>

                <GlobalButton
                    buttonText="Delete Team"
                    className="deleteButtonStyle"
                    startIcon={<DeleteOutlinedIcon />}
                    onClick={() => setDeleteTeamPopup(true)}
                    sx={{ marginTop: "16px", color: "#CF2C2C !important", borderColor: "#CF2C2C !important" }}
                />
            </Box>

            {/* Delete Team Popup */}
            {deleteTeamPopup && (
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete "${team?.organization_team_name}" team`}
                    open={deleteTeamPopup}
                    onClose={() => setDeleteTeamPopup(false)}
                    onDelete={handleDeleteTeamApiCall}
                />
            )}
        </>
    );
};

export default TeamSettings;
